import { Router } from 'aurelia-router';
import { I18N } from 'aurelia-i18n';
import { mock, instance, verify, when, anyNumber, anything } from 'ts-mockito';
import { State } from './global-state';
import { ApiResponse } from '../models/api-response';
import { SessionManager } from './session-manager';
import { HPFServiceClient } from '../../ClientApp/services/hpfApi';
import * as JWT from 'jwt-decode';

describe('NewPortalWeb', () => {
	describe('services', () => {
		describe('SessionManager', () => {
			let svc: SessionManager;
			const mockState: State = mock(State);
			const mockHpfApi: HPFServiceClient = mock(HPFServiceClient);
			const mockRouter: Router = mock(Router);
			const anonymousToken: string = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJCdXNpbmVzc0tleSI6IjEwMTYiLCJuYmYiOjE2NDQ0NDA5MjQsImV4cCI6MTY0NDQ0MjEyNCwiaWF0IjoxNjQ0NDQwOTI0fQ.Qsk-GtL7lbQ_frULRYaumpVscx0bgOiT8u14BctqWS4';
			const token: string = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJCdXNpbmVzc0tleSI6IjEwMTYiLCJVc2VyS2V5IjoiNyIsIkNvbnN1bWVyVXNlcktleSI6IjEwMzUiLCJuYmYiOjE2NDQ0NDEwMDIsImV4cCI6MTY0NDQ0MjIwMiwiaWF0IjoxNjQ0NDQxMDAyfQ.Ab8uMgKcTXeT2-63hEOFip5DPBw9ECC5jXyLxygw5zw';

			beforeEach(() => {
				svc = new SessionManager(
					instance(mockHpfApi),
					instance(mockState)
				);

			});

			describe('ShouldUpdateToken', () => {
				it('should not update if business or token are indefined', () => {
					when(mockState.business).thenReturn(null);
					when(mockState.token).thenReturn(null);
					expect(svc.shouldUpdateToken()).toBeFalsy();

					when(mockState.business).thenReturn({});
					when(mockState.token).thenReturn(null);
					expect(svc.shouldUpdateToken()).toBeFalsy();

					when(mockState.business).thenReturn(null);
					when(mockState.token).thenReturn('arstarts');
					expect(svc.shouldUpdateToken()).toBeFalsy();
				});

			});

			describe('ShouldAuthenticateSession', () => {
				it('should be authenticated when jwt contains consumerUserKeykey and is not expired', () => {
					spyOn(svc, 'getJwtTimeToExpire').and.returnValue(1);
					when(mockState.token).thenReturn(token);
					expect(svc.isAuthenticated()).toBeTruthy();
				});

				it('should not be authenticated when jwt does not contain consumerUserKey', () => {
					spyOn(svc, 'getJwtTimeToExpire').and.returnValue(1);
					when(mockState.token).thenReturn(anonymousToken);
					expect(svc.isAuthenticated()).toBeFalsy();
				});

				it('should not be authenticated when jwt is expired', () => {
					spyOn(svc, 'getJwtTimeToExpire').and.returnValue(0);
					when(mockState.token).thenReturn(token);
					expect(svc.isAuthenticated()).toBeFalsy();
				});
			});
		});
	});
});
